import { GoogleLogin } from '@react-oauth/google';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

function AdminSignUp() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [showModal, setShowModal] = useState(false);

  // Handle Google login success
  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      // Send credential to backend for verification and registration/login
      const res = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/admin/google-login`, {
        token: credentialResponse.credential,
      });

      // 🛑 FIX: Extract and save the JWT token from the backend response
      const { token, userId, role } = res.data; 

      if (token) {
          // Save the JWT (this completes the login process)
          localStorage.setItem("token", token);
          localStorage.setItem("userId", userId);
          localStorage.setItem("userRole", role);

          // Now show the success modal (or navigate directly)
          setShowModal(true); 
      } else {
          // Fallback if backend didn't return a token but didn't throw an error
          setError("Registration successful, but login token missing.");
      }

    } catch (err) {
      // Log the detailed error for debugging
      console.error("Google login failed on client:", err.response?.data || err.message);
      setError("Google login failed. Please try again.");
    }
  };

  return (
    <div className="flex flex-col md:flex-row justify-center items-center bg-gray-100 min-h-screen p-6"
      style={{
        backgroundImage: "url('/assets/img/bg-3.jpg')",
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}>
      <div className="flex flex-col items-center mb-10 md:mb-0 md:mr-10">
        <img
          src="/assets/img/oneHub_logo1.png"
          alt="Logo"
          className="w-32 h-32 mb-4 rounded-full shadow-lg" />
        <h1 className="text-4xl font-bold text-center bg-white px-4 py-2 rounded shadow">
          <span className="bg-black text-gray-100 px-2 rounded">One</span>Crm
        </h1>
        <h2 className="text-2xl font-bold mb-6 text-center text-black">Admin Registration</h2>
      </div>

      <div className="bg-gray-100 p-8 rounded shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center text-black">Admin Registration</h2>
        {/* Google Login Button */}
        <GoogleLogin
          onSuccess={handleGoogleSuccess}
          onError={() => setError("Google login failed.")}
        />
        {error && <p className="text-red-600 text-sm mb-4">{error}</p>}
        <p className="mt-4 text-center text-sm">Already have an account?</p>
        <button
          onClick={() => navigate("/")}
          className="block mt-2 w-full text-center bg-white text-black border border-gray-300 py-2 rounded hover:bg-gray-100"
        >
          Login
        </button>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-md shadow-xl">
            <h3 className="text-xl font-bold mb-4 text-yellow-500">Registration Successful</h3>
            <p className="mb-6">Are you sure you want to go to the login page?</p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                onClick={() => navigate("/")}
                className="px-4 py-2 bg-black text-white rounded hover:bg-gray-800"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminSignUp;
